var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliminarDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#FFC599;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.378)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(-0.378)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.055,15.016H8.731a.651.651,0,0,1-.651-.651V11.41a2.8,2.8,0,0,1,2.8-2.8H25.906a2.8,2.8,0,0,1,2.8,2.8v2.917a.651.651,0,0,1-.651.69Zm-18.672-1.3H27.4v-2.3a1.51,1.51,0,0,0-1.5-1.5H10.88a1.51,1.51,0,0,0-1.5,1.5Z",
    transform: "translate(2.441 2.601)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.138,29.418H10.919a.664.664,0,0,1-.651-.612L9.46,13.18a.652.652,0,1,1,1.3-.078l.781,14.961H24.487l.651-14.909a.664.664,0,0,1,.677-.625.651.651,0,0,1,.625.677L25.789,28.78a.651.651,0,0,1-.651.638Z",
    transform: "translate(2.858 3.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.151,25.127a.651.651,0,0,1-.651-.651V14.931a.651.651,0,0,1,1.3,0v9.545A.651.651,0,0,1,16.151,25.127Z",
    transform: "translate(4.683 4.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.071,25.127a.651.651,0,0,1-.651-.651V14.931a.651.651,0,0,1,1.3,0v9.545A.651.651,0,0,1,19.071,25.127Z",
    transform: "translate(5.565 4.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.271,25.127a.651.651,0,0,1-.651-.651V14.931a.651.651,0,0,1,1.3,0v9.545A.651.651,0,0,1,13.271,25.127Z",
    transform: "translate(3.813 4.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.258,10.547a.651.651,0,0,1-.651-.651V8.073a.26.26,0,0,0-.26-.26H14.5a.26.26,0,0,0-.26.26V9.9a.651.651,0,1,1-1.3,0V8.073A1.563,1.563,0,0,1,14.5,6.51h4.844a1.563,1.563,0,0,1,1.563,1.563V9.9A.651.651,0,0,1,20.258,10.547Z",
    transform: "translate(3.909 1.967)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminarDisabled);
export default __webpack_public_path__ + "static/media/eliminar-disabled.c449c26ab8d17be95cbfa21ef3f0dc16.svg";
export { ForwardRef as ReactComponent };